<ng-container *ngIf="currentViewState">
  <ng-container
    ntapFilterViewProvider
    [viewName]="currentViewName"
    [viewState]="currentViewStateFilter"
    #filter
  >
    <ng-container
      ntapListViewProvider
      [viewName]="currentViewName"
      [viewState]="currentViewState"
    >
      <ntap-dynamic
        [compId]="INIT_COMP_ID"
        [class]="currentViewClass"
      ></ntap-dynamic>
    </ng-container>
  </ng-container>
</ng-container>
